var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "press js-press" }),
    _vm.page_num != _vm.total_page
      ? _c("div", { staticClass: "press__load-more-buttons" }, [
          _c(
            "button",
            {
              staticClass: "button button--primary",
              on: { click: _vm.loadMore }
            },
            [_vm._v("LOAD MORE")]
          ),
          _c(
            "button",
            {
              staticClass: "button button--secondary",
              on: { click: _vm.loadAll }
            },
            [_vm._v("VIEW ALL")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }